<template>
    <component
        ref="widget"
        v-if="widget"
        :widget="widget"
        :class="classes"
        :is="widget.name"
        :options="widget.options"
    />
</template>

<script>
import Vue from 'vue';

import LandingPageTemplateWidget from '@/components/sliding-widgets/landing-page-template-widget/landing-page-template-widget';
import LandingPageTemplatePublishWidget from '@/components/sliding-widgets/landing-page-template-publish-widget';
import DomainWidget from '@/components/sliding-widgets/domain-widget/domain-widget';
import ContactAddWidget from '@/components/sliding-widgets/contact-add-widget';
import QuickAddCompanyWidget from '@/components/sliding-widgets/quick-add-company-widget';
import ListWidget from '@/components/sliding-widgets/list-widget/list-widget';
import ListUploadWidget from '@/components/sliding-widgets/list-widget/list-upload-widget';
import ListMergeWidget from '@/components/sliding-widgets/list-merge-widget';
import QuickAddTaskWidget from '@/components/sliding-widgets/task-widget';
import ActivityWidget from '@/components/sliding-widgets/activity-widget';
import ActivityTypeWidget from '@/components/sliding-widgets/activity-type-widget';
import BulkOneToOneEmailWidget from '@/components/sliding-widgets/bulk-one-to-one-email-widget';
import OneToOneEmailWidget from '@/components/sliding-widgets/one-to-one-email-widget';
import CollateralInjectWidget from '@/components/sliding-widgets/collateral-inject-widget';
import EmailTemplateWidget from '@/components/sliding-widgets/email-template-widget';
import EmailTemplateStagingWidget from '@/components/sliding-widgets/email-template-staging-widget';
import PlainTextEmailTemplatesWidget from '@/components/sliding-widgets/plain-text-email-templates-widget';
import GraphicalEmailTemplatesWidget from '@/components/sliding-widgets/graphical-email-templates-widget';
import DatePickerWidget from '@/components/sliding-widgets/date-picker-widget';
import AddCollateralWidget from '@/components/sliding-widgets/collateral-add-widget';
import TemplatePublishWidget from '@/components/sliding-widgets/template-publish-widget';
import CollateralPublishWidget from '@/components/sliding-widgets/collateral-publish-widget';
import EmailTemplatePublishWidget from '@/components/sliding-widgets/email-template-publish-widget';
import CompanyTypesWidget from '@/components/sliding-widgets/company-types-widget';
import AccountDetailsWidget from '@/components/sliding-widgets/account-details-widget';
import AccountProfileWidget from '@/components/sliding-widgets/account-profile-widget';
import CompanyTypeWidget from '@/components/sliding-widgets/company-type-widget';
import OpportunityTypeWidget from '@/components/sliding-widgets/opportunity-type-widget';
import ContactStatusWidget from '@/components/sliding-widgets/contact-status-widget';
import OpportunityStatusWidget from '@/components/sliding-widgets/opportunity-status-widget';
import OpportunityTypesWidget from '@/components/sliding-widgets/opportunity-types-widget';
import OpportunityLineItemsWidget from '@/components/sliding-widgets/opportunity-line-items-widget';
import OpportunityStatusesWidget from '@/components/sliding-widgets/opportunity-statuses-widget';
import ContactStatusesWidget from '@/components/sliding-widgets/contact-statuses-widget/contact-statuses-widget';
import ContactJourneysWidget from '@/components/sliding-widgets/contact-journeys-widget';
import ContactJourneyStepsWidget from '@/components/sliding-widgets/contact-journey-steps-widget';
import ActivitiesWidget from '@/components/sliding-widgets/activities-widget';
import ClientPublishWidget from '@/components/sliding-widgets/client-publish-widget';
import ConnectWiseSendContactWidget from '@/components/sliding-widgets/connectwise-send-contact-widget';
import ConnectWiseSendCompanyWidget from '@/components/sliding-widgets/connectwise-send-company-widget';
import HaloPSASendContactWidget from '@/components/sliding-widgets/halopsa-send-contact-widget';
import HaloPSASendCompanyWidget from '@/components/sliding-widgets/halopsa-send-company-widget';
import KaseyaSendCompanyWidget from '@/components/sliding-widgets/kaseya-send-company-widget';
import KaseyaSendContactWidget from '@/components/sliding-widgets/kaseya-send-contact-widget';
import SalesforceSendContactWidget from '@/components/sliding-widgets/salesforce-send-contact-widget';
import AutotaskExportCompanyWidget from '@/components/sliding-widgets/autotask-export-widget/autotask-export-company-widget';
import AutotaskExportContactWidget from '@/components/sliding-widgets/autotask-export-widget/autotask-export-contact-widget';
import SalesforceSendCompanyWidget from '@/components/sliding-widgets/salesforce-send-company-widget';
import HubSpotSendCompanyWidget from '@/components/sliding-widgets/hubspot-send-company-widget';
import HubSpotSendContactWidget from '@/components/sliding-widgets/hubspot-send-contact-widget';
import SyncroSendContactWidget from '@/components/sliding-widgets/syncro-send-contact-widget';
import SyncroSendCompanyWidget from '@/components/sliding-widgets/syncro-send-company-widget';
import CompanyVerticalWidget from '@/components/sliding-widgets/company-vertical-widget';
import VerticalWidget from '@/components/sliding-widgets/vertical-widget';
import GlobalCategoryWidget from '@/components/sliding-widgets/global-category-widget';
import SubscriptionPlanWidget from '@/components/sliding-widgets/subscription-plan-widget';
import CompanyNotesWidget from '@/components/sliding-widgets/company-activities/company-notes-widget';
import CompanyFilesWidget from '@/components/sliding-widgets/company-activities/company-files-widget';
import CompanyEditWidget from '@/components/sliding-widgets/company-edit-widget';
import CompanyMergeWidget from '@/components/sliding-widgets/company-merge-widget';
import ContactEditWidget from '@/components/sliding-widgets/contact-edit-widget';
import ContactSubscribeWidget from '@/components/sliding-widgets/contact-subscribe-widget';
import CollateralEditWidget from '@/components/sliding-widgets/collateral-edit-widget';
import AgencyWidget from '@/components/sliding-widgets/agency-widget';
import JourneyEmailStepWidget from '@/components/sliding-widgets/journey-email-step-widget';
import JourneyStepContactsWidget from '@/components/sliding-widgets/journey-step-contacts-widget';
import JourneyDelayStepWidget from '@/components/sliding-widgets/journey-delay-step-widget';
import JourneyTaskStepWidget from '@/components/sliding-widgets/journey-task-step-widget';
import JourneyContactUpdateStepWidget from '@/components/sliding-widgets/journey-contact-update-step-widget';
import JourneyConditionStepWidget from '@/components/sliding-widgets/journey-condition-step-widget';
import JourneyWidget from '@/components/sliding-widgets/journey-widget';
import CreateSocialPostWidget from '@/components/sliding-widgets/create-social-post-widget';
import JourneyTemplateWidget from '@/components/sliding-widgets/journey-template-widget';
import EmailOpensWidget from '@/components/sliding-widgets/email-opens-widget';
import EmailClicksWidget from '@/components/sliding-widgets/email-clicks-widget';
import JourneyEmailStepContentWidget from '@/components/sliding-widgets/journey-email-step-content-widget';
import CampaignWidget from '@/components/sliding-widgets/campaign-widget/campaign-widget';
import CampaignTemplateWidget from '@/components/sliding-widgets/campaign-template-widget/campaign-template-widget';
import CampaignContentWidget from '@/components/sliding-widgets/campaign-content-widget';
import EmailContentWidget from '@/components/sliding-widgets/email-content-widget';
import MarketingPlanWidget from '@/components/sliding-widgets/marketing-plan-widget';
import MarketingPlanTemplateWidget from '@/components/sliding-widgets/marketing-plan-template-widget';
import MarketingPlanDayOverviewWidget from '@/components/sliding-widgets/marketing-plan-day-overview-widget';
import MarketingPlanOverviewWidget from '@/components/sliding-widgets/marketing-plan-overview-widget';
import MarketingPlanTemplateOverviewWidget from '@/components/sliding-widgets/marketing-plan-template-overview-widget';
import UserWidget from '@/components/sliding-widgets/user-widget';
import JourneyEnableWidget from '@/components/sliding-widgets/journey-enable-widget';
import RegisteredDealWidget from '@/components/sliding-widgets/registered-deal-widget';
import RegisteredMeetingWidget from '@/components/sliding-widgets/registered-meeting-widget';
import DkimIntegrationWidget from '@/components/sliding-widgets/dkim-integration-widget';
import LinkBrandingWidget from '@/components/sliding-widgets/link-branding-widget';
import FormActivityWidget from '@/components/sliding-widgets/form-activity-widget';
import LandingPageFormActivityWidget from '@/components/sliding-widgets/landing-page-form-activity-widget';
import LandingPageSelectWidget from '@/components/sliding-widgets/landing-page-select-widget';
import CollateralSelectWidget from '@/components/sliding-widgets/collateral-select-widget';
import ClientWidget from '@/components/sliding-widgets/client-widget';
import AccountCompanyMonthlyQuotasWidget from '@/components/sliding-widgets/account-company-monthly-quotas-widget';
import AccountCompanyIndividualQuotaWidget from '@/components/sliding-widgets/account-company-individual-quota-widget';
import ServiceWidget from '@/components/sliding-widgets/service-widget';
import SolutionWidget from '@/components/sliding-widgets/solution-widget';
import AddExistingSolutionWidget from '@/components/sliding-widgets/solutions/add-existing-solution-widget.vue';
import InlineSolutionWidget from '@/components/sliding-widgets/solutions/inline-solution-widget.vue';
import VendorSolutionPublishWidget from '@/components/sliding-widgets/solutions/vendor-solution-publish-widget';
import CollateralBuildWidget from '@/components/sliding-widgets/collateral-build-widget';
import EmailTestWidget from '@/components/sliding-widgets/email-test-widget';
import EmailInboxManageWidget from '@/components/sliding-widgets/email-inbox-manage-widget';
import EmailInboxConnectWidget from '@/components/sliding-widgets/email-inbox-connect-widget';
import MarketingPlanTemplatePublishWidget from '@/components/sliding-widgets/marketing-plan-template-publish-widget';
import MarketingPlanInsertWidget from '@/components/sliding-widgets/marketing-plan-insert-widget';
import MarketingPlanTemplateSelectWidget from '@/components/sliding-widgets/marketing-plan-template-select-widget';
import GraphicalEmailTemplateSelectWidget from '@/components/sliding-widgets/graphical-email-template-select-widget';
import NonGraphicalEmailTemplateSelectWidget from '@/components/sliding-widgets/non-graphical-email-template-select-widget';
import NotificationViewWidget from '@/components/sliding-widgets/notifications-view-widget';
import CollateralBuildSelectWidget from '@/components/sliding-widgets/collateral-build-select-widget';
import CollateralBuildPublishWidget from '@/components/sliding-widgets/collateral-build-publish-widget';
import JourneyTemplatePublishWidget from '@/components/sliding-widgets/journey-template-publish-widget';
import CollateralOrganizationSelectWidget from '@/components/sliding-widgets/collateral-organization-select-widget';
import JourneyTemplateSelectWidget from '@/components/sliding-widgets/journey-template-select-widget';
import LandingPageTemplateSelectWidget from '@/components/sliding-widgets/landing-page-template-select-widget';
import ProfileContactSettingsWidget from '@/components/sliding-widgets/profile-contact-settings-widget';
import BoardViewWidget from '@/components/sliding-widgets/boards/board-view-widget';
import ContactListsWidget from '@/components/sliding-widgets/contact-lists-widget';
import LandingPageSettingsWidget from '@/components/sliding-widgets/landing-page/settings/landing-page-settings-widget';
import DocumentWidget from '@/components/sliding-widgets/document/document-widget';
import RecipientWidget from '@/components/sliding-widgets/document/recipient-widget';
import RecipientStatusesWidget from '@/components/sliding-widgets/document/recipient-statuses-widget';
import DocumentTemplateWidget from '@/components/sliding-widgets/document/document-template-widget';
import DocumentTemplatePublishWidget from '@/components/sliding-widgets/document/document-template-publish-widget';
import DocumentTemplateSelectWidget from '@/components/sliding-widgets/document/document-template-select-widget';
import DocumentSolutionsWidget from '@/components/sliding-widgets/document/solution-widget/document-solutions-widget';
import DocumentSignatureWidget from '@/components/sliding-widgets/document/signature-widget/document-signature-widget';
import DuplicateWidget from '@/components/sliding-widgets/generics/duplicate-widget';
import TwoFactorAuthentication from '@/components/sliding-widgets/two-factor-auth-widget';
import PartnerAssignUsersWidget from '@/components/sliding-widgets/partner-assign-users-widget';
import PartnerInviteWidget from '@/components/sliding-widgets/partner-invite-widget';
import HeaderWidget from '@/components/sliding-widgets/headers/header-widget';
import HeaderPublishWidget from '@/components/sliding-widgets/headers/header-publish-widget';
import HeaderSelectWidget from '@/components/sliding-widgets/headers/header-select-widget';
import FooterWidget from '@/components/sliding-widgets/footers/footer-widget';
import FooterPublishWidget from '@/components/sliding-widgets/footers/footer-publish-widget';
import FooterSelectWidget from '@/components/sliding-widgets/footers/footer-select-widget';
import HeaderFooterDetailsWidget from '@/components/sliding-widgets/header-footer-details-widget';
import AddPhoneNumberWidget from '@/components/sliding-widgets/add-phone-number-widget';
import SmsWidget from '@/components/sliding-widgets/sms-widget';
import OpportunityDetailsWidget from '@/components/sliding-widgets/opportunity-details-widget/opportunity-details-widget';
import SocialMediaManageWidget from '@/components/sliding-widgets/social-media/social-media-manage-widget';
import CustomFieldWidget from '@/components/sliding-widgets/custom-field-widget';
import PartnershipWidget from '@/components/sliding-widgets/partnership-widget';
import CustomFieldOrderWidget from '@/components/sliding-widgets/custom-field-order-widget';
import UpdatesWidget from '@/components/sliding-widgets/updates-widget/updates-widget';
import PreviewUpdate from '@/components/sliding-widgets/preview-update';
import ReportScheduleWidget from '@/components/sliding-widgets/report-schedule-widget';
import FormWidget from '@/components/sliding-widgets/form-widget/form-widget';
import SocialInboxCommentsWidget from '@/components/sliding-widgets/social-media/social-media-inbox-comments-widget';
import SocialInboxPrivateMessagesWidget from '@/components/sliding-widgets/social-media/social-media-inbox-private-messages-widget';
import LibrarySelectWidget from '@/components/sliding-widgets/library-select-widget';
import ApplyToPartnershipWidget from '@/components/sliding-widgets/apply-to-partnership-widget';
import DeniedPartnershipDetailsWidget from '@/components/sliding-widgets/denied-partnership-details-widget';
import ManagePartnerRequestWidget from '@/components/sliding-widgets/manage-partner-request-widget';
import DenyReasonWidget from '@/components/sliding-widgets/deny-reason-widget';
import RevokeReasonWidget from '@/components/sliding-widgets/revoke-reason-widget';
import DateRangeWidget from '@/components/sliding-widgets/date-range-widget';
import SocialPostSelectWidget from '@/components/sliding-widgets/social-post/social-post-select-widget';
import SocialPostTemplateWidget from '@/components/sliding-widgets/social-post/social-post-template-widget';
import PaymentWidget from '@/components/sliding-widgets/payment-widget/payment-widget';
import AddCreditCardWidget from '@/components/sliding-widgets/add-credit-card-widget';
import AssignUserContactWidget from '@/components/sliding-widgets/assign-user-contact-widget';
import AssignUserCompanyWidget from '@/components/sliding-widgets/assign-user-company-widget';
import CompanySolutionsWidget from '@/components/sliding-widgets/company-solutions-widget';
import SocialPostTemplatePublishWidget from '@/components/sliding-widgets/social-post/social-post-template-publish-widget';
import SocialPostTemplateSelectWidget from '@/components/sliding-widgets/social-post/social-post-template-select-widget';
import ClientSolutionsRoadmapWidget from '@/components/sliding-widgets/company-activities/client-solutions-roadmap-widget';
import FeaturedResourceSelectWidget from '@/components/sliding-widgets/featured-resource-select-widget';
import DesignStudioBuilderWidget from '@/components/sliding-widgets/design-studio/design-studio-builder-widget';
import ContactFieldHiderWidget from '@/components/sliding-widgets/contact-field-hider-widget';
import CompanyFieldHiderWidget from '@/components/sliding-widgets/company-field-hider-widget';
import StorefrontDataPermissionWidget from '@/components/sliding-widgets/storefront-data-permission-widget';
import DenyWidget from '@/components/sliding-widgets/deny-widget';
import CategoriesEditWidget from '@/components/sliding-widgets/categories-edit-widget';
import StoreFrontRequestWidget from '@/components/sliding-widgets/storefront-request-widget';
import IconsWidget from '@/components/sliding-widgets/icons-widget';
import ReasonForDenialWidget from '@/components/sliding-widgets/reason-for-denial-widget.vue';
import MagicBrandingFontsSettingsWidget from '@/components/sliding-widgets/magic-branding/magic-branding-fonts-settings-widget.vue';
import MagicBrandingButtonWidget from '@/components/sliding-widgets/magic-branding/magic-branding-button-widget';
import APIKeyWidget from '@/components/sliding-widgets/open-api/api-key-widget';
import MarketplaceDisclaimerWidget from '@/components/sliding-widgets/marketplace-disclaimer-widget';
import ManagedStorefrontWidget from '@/components/sliding-widgets/managed-storefront-widget.vue';
import StorefrontHeaderImageWidget from '@/components/sliding-widgets/storefront-header-image-widget.vue';
import DistributorsWidget from '@/components/sliding-widgets/distributors-widget.vue';
import CustomInsertTagWidget from '@/components/sliding-widgets/custom-insert-tag-widget';
import DocumentDenialWidget from '@/components/sliding-widgets/document-denial-widget.vue';
import MdfActivitiesWidget from '@/components/sliding-widgets/mdf/mdf-activities-widget.vue';
import MdfRegisteredDealsWidget from '@/components/sliding-widgets/mdf/mdf-registered-deals-widget.vue';
import MDFAssignUsersWidget from '@/components/sliding-widgets/mdf/mdf-assign-users-widget.vue';
import MDFAddBudgetWidget from '@/components/sliding-widgets/mdf/mdf-add-budget-widget';
import MDFDetailsWidget from '@/components/sliding-widgets/mdf/mdf-details-widget';
import MDFAddActivityTypeWidget from '@/components/sliding-widgets/mdf/mdf-add-activity-type-widget';
import MDFGuidelineWidget from '@/components/sliding-widgets/mdf/mdf-guideline-widget';
import MDFPayFundsWidget from '@/components/sliding-widgets/mdf-pay-funds-widget/mdf-pay-funds-widget';
import MDFSubmitPopWidget from '@/components/sliding-widgets/mdf/mdf-submit-pop-widget';
import AccountCompanyOpportunitiesWidget from '@/components/sliding-widgets/account-company-opportunities-widget.vue';
import AccountCompanyPreferredCurrencyWidget from '@/components/sliding-widgets/account-company-preferred-currency-widget.vue';
import OpportunityManageStagesWidget from '@/components/sliding-widgets/opportunities-manage-stages-widget.vue';
import PSurveyWidget from '@/components/sliding-widgets/psurvey-widget.vue';
import DocumentUploadPdfWidget from '@/components/sliding-widgets/document/document-upload-pdf-widget.vue';
import FormDetailsWidget from '@/components/sliding-widgets/form-details-widget';
import LandingPageFormPublishWidget from '@/components/sliding-widgets/landing-page-form-publish-widget';
import LandingPageFormSelectWidget from '@/components/sliding-widgets/landing-page-form-select-widget';
import FormFromTemplateWidget from '@/components/sliding-widgets/form-from-template-widget';
import PreviouslyLoggedActivityWidget from '@/components/sliding-widgets/previously-logged-activity-widget';
import AddActivityToOpportunityWidget from '@/components/sliding-widgets/add-activity-to-opportunity-widget';
import PSurveyDetailsWidget from '@/components/sliding-widgets/psurvey-details-widget';
import PSurveyPublishWidget from '@/components/sliding-widgets/psurvey-publish-widget';
import ContactSalesRepWidget from '@/components/sliding-widgets/contact-sales-rep-widget';
import AddBankAccountWidget from '@/components/sliding-widgets/add-bank-account-widget';
import InvoiceDetailsWidget from '@/components/sliding-widgets/invoice-details-widget';
import MDFPaymentWidget from '@/components/sliding-widgets/mdf-payment-widget/mdf-payment-widget';
import ProofOfPaymentWidget from '@/components/sliding-widgets/proof-of-payment-widget';
import EditProofOfPaymentWidget from '@/components/sliding-widgets/edit-proof-of-payment-widget';
import CreateStripeAccountWidget from '@/components/sliding-widgets/create-stripe-account-widget';
import VerifyBankAccountWidget from '@/components/sliding-widgets/verify-bank-account-widget';
import UploadSolutionCsvWidgetVue from './solutions/upload-solution-csv-widget.vue';
import AppointmentRequestWidget
    from '@/components/sliding-widgets/appointment-request-widget/appointment-request-widget.vue';
import AppointmentRequestDetailsWidget
    from '@/components/sliding-widgets/appointment-request-details-widget/appointment-request-details-widget.vue';

import ExitSurveyDetailsWidget
from '@/components/sliding-widgets/exit-survey-details-widget/exit-survey-details-widget.vue';
import ExitSurveyResponseDetailsWidget
    from '@/components/sliding-widgets/exit-survey-response-details-widget/exit-survey-response-details-widget.vue';
import RegisteredDealsWidget from '@/components/sliding-widgets/registered-deal-widget/registered-deal-widget.vue';

import EventBus from '@/scripts/event-bus.js';


Vue.component(LandingPageTemplateWidget.name, LandingPageTemplateWidget);
Vue.component(LandingPageTemplatePublishWidget.name, LandingPageTemplatePublishWidget);
Vue.component(DomainWidget.name, DomainWidget);
Vue.component(ContactAddWidget.name, ContactAddWidget);
Vue.component(QuickAddCompanyWidget.name, QuickAddCompanyWidget);
Vue.component(QuickAddTaskWidget.name, QuickAddTaskWidget);
Vue.component(ListWidget.name, ListWidget);
Vue.component(ListUploadWidget.name, ListUploadWidget);
Vue.component(ListMergeWidget.name, ListMergeWidget);
Vue.component(ActivityWidget.name, ActivityWidget);
Vue.component(ActivityTypeWidget.name, ActivityTypeWidget);
Vue.component(BulkOneToOneEmailWidget.name, BulkOneToOneEmailWidget);
Vue.component(OneToOneEmailWidget.name, OneToOneEmailWidget);
Vue.component(CollateralInjectWidget.name, CollateralInjectWidget);
Vue.component(EmailTemplateWidget.name, EmailTemplateWidget);
Vue.component(EmailTemplateStagingWidget.name, EmailTemplateStagingWidget);
Vue.component(PlainTextEmailTemplatesWidget.name, PlainTextEmailTemplatesWidget);
Vue.component(GraphicalEmailTemplatesWidget.name, GraphicalEmailTemplatesWidget);
Vue.component(DatePickerWidget.name, DatePickerWidget);
Vue.component(AddCollateralWidget.name, AddCollateralWidget);
Vue.component(TemplatePublishWidget.name, TemplatePublishWidget);
Vue.component(CollateralPublishWidget.name, CollateralPublishWidget);
Vue.component(EmailTemplatePublishWidget.name, EmailTemplatePublishWidget);
Vue.component(CompanyTypesWidget.name, CompanyTypesWidget);
Vue.component(CompanyTypeWidget.name, CompanyTypeWidget);
Vue.component(AccountDetailsWidget.name, AccountDetailsWidget);
Vue.component(AccountProfileWidget.name, AccountProfileWidget);
Vue.component(OpportunityTypeWidget.name, OpportunityTypeWidget);
Vue.component(ContactStatusWidget.name, ContactStatusWidget);
Vue.component(ContactJourneysWidget.name, ContactJourneysWidget);
Vue.component(ContactJourneyStepsWidget.name, ContactJourneyStepsWidget);
Vue.component(OpportunityStatusWidget.name, OpportunityStatusWidget);
Vue.component(OpportunityTypesWidget.name, OpportunityTypesWidget);
Vue.component(OpportunityLineItemsWidget.name, OpportunityLineItemsWidget);
Vue.component(OpportunityStatusesWidget.name, OpportunityStatusesWidget);
Vue.component(ContactStatusesWidget.name, ContactStatusesWidget);
Vue.component(ActivitiesWidget.name, ActivitiesWidget);
Vue.component(ClientPublishWidget.name, ClientPublishWidget);
Vue.component(ConnectWiseSendContactWidget.name, ConnectWiseSendContactWidget);
Vue.component(ConnectWiseSendCompanyWidget.name, ConnectWiseSendCompanyWidget);
Vue.component(HaloPSASendContactWidget.name, HaloPSASendContactWidget);
Vue.component(HaloPSASendCompanyWidget.name, HaloPSASendCompanyWidget);
Vue.component(KaseyaSendCompanyWidget.name, KaseyaSendCompanyWidget);
Vue.component(KaseyaSendContactWidget.name, KaseyaSendContactWidget);
Vue.component(CompanyVerticalWidget.name, CompanyVerticalWidget);
Vue.component(VerticalWidget.name, VerticalWidget);
Vue.component(GlobalCategoryWidget.name, GlobalCategoryWidget);
Vue.component(SubscriptionPlanWidget.name, SubscriptionPlanWidget);
Vue.component(CompanyNotesWidget.name, CompanyNotesWidget);
Vue.component(CompanyFilesWidget.name, CompanyFilesWidget);
Vue.component(CompanyEditWidget.name, CompanyEditWidget);
Vue.component(ContactEditWidget.name, ContactEditWidget);
Vue.component(ContactSubscribeWidget.name, ContactSubscribeWidget);
Vue.component(CompanyMergeWidget.name, CompanyMergeWidget);
Vue.component(CollateralEditWidget.name, CollateralEditWidget);
Vue.component(AgencyWidget.name, AgencyWidget);
Vue.component(JourneyEmailStepWidget.name, JourneyEmailStepWidget);
Vue.component(JourneyTaskStepWidget.name, JourneyTaskStepWidget);
Vue.component(JourneyStepContactsWidget.name, JourneyStepContactsWidget);
Vue.component(JourneyDelayStepWidget.name, JourneyDelayStepWidget);
Vue.component(JourneyContactUpdateStepWidget.name, JourneyContactUpdateStepWidget);
Vue.component(JourneyConditionStepWidget.name, JourneyConditionStepWidget);
Vue.component(JourneyWidget.name, JourneyWidget);
Vue.component(CreateSocialPostWidget.name, CreateSocialPostWidget);
Vue.component(JourneyTemplateWidget.name, JourneyTemplateWidget);
Vue.component(EmailOpensWidget.name, EmailOpensWidget);
Vue.component(EmailClicksWidget.name, EmailClicksWidget);
Vue.component(CampaignWidget.name, CampaignWidget);
Vue.component(CampaignTemplateWidget.name, CampaignTemplateWidget);
Vue.component(CampaignContentWidget.name, CampaignContentWidget);
Vue.component(EmailContentWidget.name, EmailContentWidget);
Vue.component(JourneyEmailStepContentWidget.name, JourneyEmailStepContentWidget);
Vue.component(MarketingPlanWidget.name, MarketingPlanWidget);
Vue.component(MarketingPlanTemplateWidget.name, MarketingPlanTemplateWidget);
Vue.component(MarketingPlanDayOverviewWidget.name, MarketingPlanDayOverviewWidget);
Vue.component(MarketingPlanOverviewWidget.name, MarketingPlanOverviewWidget);
Vue.component(MarketingPlanTemplateOverviewWidget.name, MarketingPlanTemplateOverviewWidget);
Vue.component(UserWidget.name, UserWidget);
Vue.component(JourneyEnableWidget.name, JourneyEnableWidget);
Vue.component(RegisteredDealWidget.name, RegisteredDealWidget);
Vue.component(RegisteredMeetingWidget.name, RegisteredMeetingWidget);
Vue.component(SalesforceSendCompanyWidget.name, SalesforceSendCompanyWidget);
Vue.component(SalesforceSendContactWidget.name, SalesforceSendContactWidget);
Vue.component(HubSpotSendCompanyWidget.name, HubSpotSendCompanyWidget);
Vue.component(HubSpotSendContactWidget.name, HubSpotSendContactWidget);
Vue.component(AutotaskExportCompanyWidget.name, AutotaskExportCompanyWidget);
Vue.component(AutotaskExportContactWidget.name, AutotaskExportContactWidget);
Vue.component(SyncroSendContactWidget.name, SyncroSendContactWidget);
Vue.component(SyncroSendCompanyWidget.name, SyncroSendCompanyWidget);
Vue.component(DkimIntegrationWidget.name, DkimIntegrationWidget);
Vue.component(FormActivityWidget.name, FormActivityWidget);
Vue.component(LandingPageFormActivityWidget.name, LandingPageFormActivityWidget);
Vue.component(LandingPageSelectWidget.name, LandingPageSelectWidget);
Vue.component(CollateralSelectWidget.name, CollateralSelectWidget);
Vue.component(ClientWidget.name, ClientWidget);
Vue.component(AccountCompanyMonthlyQuotasWidget.name, AccountCompanyMonthlyQuotasWidget);
Vue.component(AccountCompanyIndividualQuotaWidget.name, AccountCompanyIndividualQuotaWidget);
Vue.component(ServiceWidget.name, ServiceWidget);
Vue.component(SolutionWidget.name, SolutionWidget);
Vue.component(AddExistingSolutionWidget.name, AddExistingSolutionWidget);
Vue.component(InlineSolutionWidget.name, InlineSolutionWidget);
Vue.component(VendorSolutionPublishWidget.name, VendorSolutionPublishWidget);
Vue.component(CollateralBuildWidget.name, CollateralBuildWidget);
Vue.component(EmailTestWidget.name, EmailTestWidget);
Vue.component(EmailInboxManageWidget.name, EmailInboxManageWidget);
Vue.component(EmailInboxConnectWidget.name, EmailInboxConnectWidget);
Vue.component(MarketingPlanTemplatePublishWidget.name, MarketingPlanTemplatePublishWidget);
Vue.component(MarketingPlanInsertWidget.name, MarketingPlanInsertWidget);
Vue.component(LinkBrandingWidget.name, LinkBrandingWidget);
Vue.component(MarketingPlanTemplateSelectWidget.name, MarketingPlanTemplateSelectWidget);
Vue.component(GraphicalEmailTemplateSelectWidget.name, GraphicalEmailTemplateSelectWidget);
Vue.component(NonGraphicalEmailTemplateSelectWidget.name, NonGraphicalEmailTemplateSelectWidget);
Vue.component(NotificationViewWidget.name, NotificationViewWidget);
Vue.component(CollateralBuildSelectWidget.name, CollateralBuildSelectWidget);
Vue.component(CollateralBuildPublishWidget.name, CollateralBuildPublishWidget);
Vue.component(JourneyTemplatePublishWidget.name, JourneyTemplatePublishWidget);
Vue.component(CollateralOrganizationSelectWidget.name, CollateralOrganizationSelectWidget);
Vue.component(JourneyTemplateSelectWidget.name, JourneyTemplateSelectWidget);
Vue.component(LandingPageTemplateSelectWidget.name, LandingPageTemplateSelectWidget);
Vue.component(ProfileContactSettingsWidget.name, ProfileContactSettingsWidget);
Vue.component(BoardViewWidget.name, BoardViewWidget);
Vue.component(ContactListsWidget.name, ContactListsWidget);
Vue.component(LandingPageSettingsWidget.name, LandingPageSettingsWidget);
Vue.component(DocumentWidget.name, DocumentWidget);
Vue.component(RecipientWidget.name, RecipientWidget);
Vue.component(RecipientStatusesWidget.name, RecipientStatusesWidget);
Vue.component(DocumentTemplateWidget.name, DocumentTemplateWidget);
Vue.component(DocumentTemplatePublishWidget.name, DocumentTemplatePublishWidget);
Vue.component(DocumentTemplateSelectWidget.name, DocumentTemplateSelectWidget);
Vue.component(DocumentSolutionsWidget.name, DocumentSolutionsWidget);
Vue.component(DocumentSignatureWidget.name, DocumentSignatureWidget);
Vue.component(DuplicateWidget.name, DuplicateWidget);
Vue.component(TwoFactorAuthentication.name, TwoFactorAuthentication);
Vue.component(PartnerAssignUsersWidget.name, PartnerAssignUsersWidget);
Vue.component(PartnerInviteWidget.name, PartnerInviteWidget);
Vue.component(HeaderWidget.name, HeaderWidget);
Vue.component(HeaderSelectWidget.name, HeaderSelectWidget);
Vue.component(HeaderPublishWidget.name, HeaderPublishWidget);
Vue.component(FooterWidget.name, FooterWidget);
Vue.component(FooterPublishWidget.name, FooterPublishWidget);
Vue.component(FooterSelectWidget.name, FooterSelectWidget);
Vue.component(HeaderFooterDetailsWidget.name, HeaderFooterDetailsWidget);
Vue.component(AddPhoneNumberWidget.name, AddPhoneNumberWidget);
Vue.component(SmsWidget.name, SmsWidget);
Vue.component(OpportunityDetailsWidget.name, OpportunityDetailsWidget);
Vue.component(SocialMediaManageWidget.name, SocialMediaManageWidget);
Vue.component(CustomFieldWidget.name, CustomFieldWidget);
Vue.component(CustomFieldOrderWidget.name, CustomFieldOrderWidget);
Vue.component(UpdatesWidget.name, UpdatesWidget);
Vue.component(PreviewUpdate.name, PreviewUpdate);
Vue.component(ReportScheduleWidget.name, ReportScheduleWidget);
Vue.component(FormWidget.name, FormWidget);
Vue.component(SocialInboxCommentsWidget.name, SocialInboxCommentsWidget);
Vue.component(SocialInboxPrivateMessagesWidget.name, SocialInboxPrivateMessagesWidget);
Vue.component(LibrarySelectWidget.name, LibrarySelectWidget);
Vue.component(ApplyToPartnershipWidget.name, ApplyToPartnershipWidget);
Vue.component(DeniedPartnershipDetailsWidget.name, DeniedPartnershipDetailsWidget);
Vue.component(ManagePartnerRequestWidget.name, ManagePartnerRequestWidget);
Vue.component(DenyReasonWidget.name, DenyReasonWidget);
Vue.component(RevokeReasonWidget.name, RevokeReasonWidget);
Vue.component(DateRangeWidget.name, DateRangeWidget);
Vue.component(SocialPostSelectWidget.name, SocialPostSelectWidget);
Vue.component(SocialPostTemplateWidget.name, SocialPostTemplateWidget);
Vue.component(PaymentWidget.name, PaymentWidget);
Vue.component(AddCreditCardWidget.name,AddCreditCardWidget);
Vue.component(AssignUserContactWidget.name,AssignUserContactWidget);
Vue.component(AssignUserCompanyWidget.name,AssignUserCompanyWidget);
Vue.component(CompanySolutionsWidget.name,CompanySolutionsWidget);
Vue.component(SocialPostTemplatePublishWidget.name, SocialPostTemplatePublishWidget);
Vue.component(SocialPostTemplateSelectWidget.name, SocialPostTemplateSelectWidget);
Vue.component(ClientSolutionsRoadmapWidget.name, ClientSolutionsRoadmapWidget);
Vue.component(FeaturedResourceSelectWidget.name, FeaturedResourceSelectWidget);
Vue.component(DesignStudioBuilderWidget.name, DesignStudioBuilderWidget);
Vue.component(ContactFieldHiderWidget.name, ContactFieldHiderWidget);
Vue.component(CompanyFieldHiderWidget.name, CompanyFieldHiderWidget);
Vue.component(StorefrontDataPermissionWidget.name, StorefrontDataPermissionWidget);
Vue.component(ReasonForDenialWidget.name, ReasonForDenialWidget);
Vue.component(DenyWidget.name, DenyWidget);
Vue.component(PartnershipWidget.name, PartnershipWidget);
Vue.component(CategoriesEditWidget.name, CategoriesEditWidget);
Vue.component(StoreFrontRequestWidget.name, StoreFrontRequestWidget);
Vue.component(IconsWidget.name, IconsWidget);
Vue.component(MagicBrandingFontsSettingsWidget.name, MagicBrandingFontsSettingsWidget);
Vue.component(MagicBrandingButtonWidget.name, MagicBrandingButtonWidget);
Vue.component(APIKeyWidget.name, APIKeyWidget);
Vue.component(MarketplaceDisclaimerWidget.name, MarketplaceDisclaimerWidget);
Vue.component(ManagedStorefrontWidget.name, ManagedStorefrontWidget);
Vue.component(StorefrontHeaderImageWidget.name, StorefrontHeaderImageWidget);
Vue.component(CustomInsertTagWidget.name, CustomInsertTagWidget);
Vue.component(DistributorsWidget.name, DistributorsWidget);
Vue.component(DocumentDenialWidget.name, DocumentDenialWidget);
Vue.component(MdfActivitiesWidget.name, MdfActivitiesWidget);
Vue.component(MdfRegisteredDealsWidget.name, MdfRegisteredDealsWidget);
Vue.component(MDFAssignUsersWidget.name, MDFAssignUsersWidget);
Vue.component(MDFAddBudgetWidget.name, MDFAddBudgetWidget);
Vue.component(MDFDetailsWidget.name, MDFDetailsWidget);
Vue.component(MDFAddActivityTypeWidget.name, MDFAddActivityTypeWidget);
Vue.component(MDFGuidelineWidget.name, MDFGuidelineWidget);
Vue.component(MDFPayFundsWidget.name, MDFPayFundsWidget);
Vue.component(MDFSubmitPopWidget.name, MDFSubmitPopWidget);
Vue.component(AccountCompanyOpportunitiesWidget.name, AccountCompanyOpportunitiesWidget);
Vue.component(AccountCompanyPreferredCurrencyWidget.name, AccountCompanyPreferredCurrencyWidget);
Vue.component(OpportunityManageStagesWidget.name, OpportunityManageStagesWidget);
Vue.component(PSurveyWidget.name, PSurveyWidget);
Vue.component(DocumentUploadPdfWidget.name, DocumentUploadPdfWidget);
Vue.component(FormDetailsWidget.name, FormDetailsWidget);
Vue.component(LandingPageFormPublishWidget.name, LandingPageFormPublishWidget);
Vue.component(LandingPageFormSelectWidget.name, LandingPageFormSelectWidget);
Vue.component(FormFromTemplateWidget.name, FormFromTemplateWidget);
Vue.component(PreviouslyLoggedActivityWidget.name, PreviouslyLoggedActivityWidget);
Vue.component(AddActivityToOpportunityWidget.name, AddActivityToOpportunityWidget);
Vue.component(PSurveyDetailsWidget.name, PSurveyDetailsWidget);
Vue.component(PSurveyPublishWidget.name, PSurveyPublishWidget);
Vue.component(ContactSalesRepWidget.name, ContactSalesRepWidget);
Vue.component(AddBankAccountWidget.name, AddBankAccountWidget);
Vue.component(InvoiceDetailsWidget.name, InvoiceDetailsWidget);
Vue.component(MDFPaymentWidget.name, MDFPaymentWidget);
Vue.component(ProofOfPaymentWidget.name, ProofOfPaymentWidget);
Vue.component(EditProofOfPaymentWidget.name, EditProofOfPaymentWidget)
Vue.component(CreateStripeAccountWidget.name, CreateStripeAccountWidget);
Vue.component(VerifyBankAccountWidget.name, VerifyBankAccountWidget);
Vue.component(UploadSolutionCsvWidgetVue.name, UploadSolutionCsvWidgetVue);
Vue.component(AppointmentRequestWidget.name, AppointmentRequestWidget);
Vue.component(AppointmentRequestDetailsWidget.name, AppointmentRequestDetailsWidget);
Vue.component(ExitSurveyDetailsWidget.name, ExitSurveyDetailsWidget);
Vue.component(ExitSurveyResponseDetailsWidget.name, ExitSurveyResponseDetailsWidget);
Vue.component(RegisteredDealsWidget.name, RegisteredDealsWidget);

export default {
    name: 'sliding-widget',

    props: {
        widget: {
            type: Object,
        },

        options: {
            type: Object,
            default: null,
        },

        index: {
            type: Number,
            required: true,
        },
    },

    computed: {
        classes() {
            return this.index == 1 ? 'blue-gradient-header' : 'purple-gradient-header';
        },
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget');
        },
    },

    mounted() {
        this.$helpers.hideBodyOverflow();
    },
};
</script>

<style>
.widget {
    height: 100%;
    width: 100%;
    position: fixed;
    display: flex;
    flex-wrap: wrap;
    top: 0%;
    right: 0px;
    background: #ffffff;
    z-index: 10041;
    border-top-left-radius: 19px;
    border-bottom-left-radius: 19px;
    box-shadow: -6px -6px 12px rgba(130, 116, 232, 0.2);
}

.widget.slide-enter-active,
.widget.slide-leave-active {
    transition: right 0.3s;
}

.widget.slide-enter,
.widget.slide-leave-to {
    right: -700px;
}

.widget .widget-contents-container {
    width: 100%;
    height: 100%;
    position: relative;
}

.widget .widget-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 25px 0px 35px;
    height: 67px;
    width: 100%;
    border-top-left-radius: 19px;
}

.widget.purple-gradient-header .widget-header {
    background: rgb(130, 116, 232);
    background: linear-gradient(90deg, rgba(130, 116, 232, 1) 0%, rgba(198, 121, 208, 1) 100%);
}

.widget.blue-gradient-header .widget-header {
    background: rgb(80, 82, 254);
    background: linear-gradient(90deg, rgba(80, 82, 254, 1) 0%, rgba(75, 201, 254, 1) 100%);
}

.widget .widget-header h3 {
    color: #ffffff;
    margin-bottom: 0;
}

.widget .widget-header .widget-close-button {
    cursor: pointer;
}

.widget.dropdown-shown .widget-header .widget-close-button svg {
    position: relative;
    z-index: 2;
    height: 18px;
    width: 18px;
}

.widget .content-wrapper {
    width: 100%;
    height: calc(100% - 152px);
    overflow: auto;
    padding: 45px 35px;
}

.widget .content-wrapper::-webkit-scrollbar {
    width: 9px;
    height: 9px;
}

.widget .content-wrapper::-webkit-scrollbar-track {
    border-radius: 32px;
}

.widget .content-wrapper::-webkit-scrollbar-thumb {
    border-radius: 32px;
    background: #e9e9ef;
}

.widget .widget-footer {
    padding: 0px 90px 0px 35px;
    height: 85px;
    width: 100%;
    background: #f7f7f8;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: flex-end;
    border-bottom-left-radius: 19px;
}

@media only screen and (max-width: 720px) {
    .widget .widget-footer {
        padding: 0 20px;
    }

    .widget .btn.normal {
        padding: 0 20px;
    }
}

.fake-content {
    height: 5000px;
    width: 100%;
}

/* FROAL */
.widget .fr-toolbar.fr-top {
    background: #8274e8;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    border: none;
    border-radius: 7px 7px 0 0;
    -moz-border-radius: 7px 7px 0 0;
    -webkit-border-radius: 7px 7px 0 0;
}

.marketplace-disclaimer-widget .fr-toolbar.fr-top {
    background: transparent linear-gradient(266deg, #e38dee 0%, #7a5bff 100%) 0% 0% no-repeat
        padding-box;
}

.widget #color-1 img {
    margin: 10px;
    width: 18px;
}

.widget .fr-box.fr-basic.fr-top .fr-wrapper {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    border: 1px solid #e9e9ef;
    border-radius: 0 0 7px 7px;
    -moz-border-radius: 0 0 7px 7px;
    -webkit-border-radius: 0 0 7px 7px;
}

.widget .fr-box.fr-basic .fr-element,
.widget .fr-box.fr-basic.fr-top .fr-wrapper {
    min-height: 200px;
}

.widget .fr-toolbar .fr-command.fr-btn {
    color: #fff;
}

.fr-toolbar .fr-command.fr-btn i {
    color: #fff;
}

.widget .fr-toolbar .fr-command:hover,
.widget .fr-toolbar .fr-command:focus {
    color: #fff;
    background: #ada2fb;
}

.fr-popup {
    z-index: 1080 !important;
}

.widget .fr-toolbar .fr-command.fr-btn.fr-dropdown.fr-active,
.widget .fr-popup .fr-command.fr-btn.fr-dropdown.fr-active {
    background: rgb(173, 162, 251) !important;
    color: #fff !important;
}

.widget .fr-toolbar .fr-command.fr-btn.fr-dropdown.fr-active:hover,
.widget .fr-popup .fr-command.fr-btn.fr-dropdown.fr-active:hover {
    background: rgb(173, 162, 251) !important;
    color: #fff !important;
}

.widget .fr-toolbar .fr-command.fr-btn.fr-active {
    background: rgb(173, 162, 251);
}

.widget .fr-toolbar .fr-command.fr-btn.fr-dropdown::after,
.widget .fr-popup .fr-command.fr-btn.fr-dropdown::after {
    border-top: 4px solid #fff !important;
}

.widget .fr-toolbar .fr-command.fr-btn.fr-dropdown.fr-active:hover::after,
.widget .fr-popup .fr-command.fr-btn.fr-dropdown.fr-active:hover::after,
.widget .fr-toolbar .fr-command.fr-btn.fr-dropdown.fr-active:focus::after,
.widget .fr-popup .fr-command.fr-btn.fr-dropdown.fr-active:focus::after {
    border-top: 4px solid #fff !important;
}

.widget
    .fr-command.fr-btn
    + .fr-dropdown-menu
    .fr-dropdown-wrapper
    .fr-dropdown-content
    ul.fr-dropdown-list
    li
    a.fr-active {
    background: rgb(173, 162, 251);
}

.widget .fr-popup .fr-colors-tabs .fr-colors-tab:hover,
.widget .fr-popup .fr-colors-tabs .fr-colors-tab:focus {
    color: #fff;
}

.widget .fr-popup .fr-colors-tabs .fr-colors-tab {
    display: none;
}

.widget .fr-separator {
    background: rgb(173, 162, 251);
}

.widget .fr-view {
    font-family: Arial, sans-serif;
}

.widget .fr-quick-insert {
    display: none;
}
/* END FROALA */
</style>
